import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router, Route } from '@angular/router';
import {
  AlertService,
  GrowlType,
} from 'app/infrastructure/services/alert.service';
import { Translator } from 'angular-translator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmacionModalComponent } from 'app/helpers/components/confirmationModal/confirmationModal.component';
import { ProductEmailService } from "app/infrastructure/services/productEmail.service";
import {
  ProductEmail
} from 'app/infrastructure/model/classes/productEmail.class';

@Component({
  selector: 'sx-product-email-subscription-list',
  templateUrl: './product.email.subscription.list.component.html',
})
export class ProductEmailSubscriptionListComponent implements OnInit {
  organizationCode: string;
  subscriptionCode: string;
  channelCode: string;
  productCode: string;
  documentKind: string;
  preguntarSiDeseaBorrar = [];
  productEmails: ProductEmail[] = new Array<
  ProductEmail
  >();

  constructor(
    private productEmailSrv: ProductEmailService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private alertService: AlertService,
    private translate: Translator,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.organizationCode = params['codorganizacion'];
      this.subscriptionCode = params['codsistema'];
      this.channelCode = params['codnegocio'];
      this.productCode = params['codproducto'];
      this.documentKind = params['documentKind'];

      this.productEmailSrv
        .getAllSubscribed(
          this.organizationCode,
          this.subscriptionCode,
          this.channelCode,
          this.productCode
        )
        .subscribe((res) => (this.productEmails = res));
    });
  }

  clickEdit(productEmailId: string) {
    this.router.navigate(['.', productEmailId], {
      relativeTo: this.aRoute,
    });
  }

  clickDelete(productEmailId: string, name: string) {
    const modalRef = this.modalService.open(ConfirmacionModalComponent);
    const modalInstance = <ConfirmacionModalComponent>(
      modalRef.componentInstance
    );
    const text = <string>this.translate.instant('DISABLE_TEXT');

    modalInstance.titulo = `${text} ${name}?`;
    modalRef.result.then((confirmacion) => {
      this.productEmailSrv
        .unsubscribe(
          productEmailId,
          this.organizationCode,
          this.subscriptionCode,
          this.channelCode,
          this.productCode
        )
        .then((success) => {
          if (success) {
            this.alertService.showGrowl(
              {
                type: GrowlType.SUCCESS,
                body: 'SUCCESSFUL_DELETE_BUSINESS_LOGIC',
              },
              { name: name }
            );
          } else {
            this.alertService.showGrowl(
              {
                type: GrowlType.DANGER,
                body: 'COULD_NOT_DELETE_BUSINESS_LOGIC',
              },
              { name: name }
            );
          }
          this.productEmails = this.productEmails.filter(
            (f) => f.id !== productEmailId
          );
        });
    });
  }

  isPolicy() {
    return this.documentKind === 'Policy';
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product-email/subscribe/subscribe-list/product.email.subscription.list.component.ts